import client from '@config/client'
import API_URL from '@config/services'
import { ApiClientResult } from '@/types/api'

interface OrgUserPayload {
  role?: string
  title?: string
  is_active?: boolean
  [key: string]: any
}

interface OrganizationPayload {
  name: string
  industry?: string
  address?: string
  [key: string]: any
}

interface InvitePayload {
  email: string
  first_name?: string
  last_name?: string
  role?: string
  [key: string]: any
}

/**
 * Orgusers
 **/

/**
 * Fetches organization users
 * @param orgPk - Organization ID
 * @returns List of organization users
 */
export const fetchOrguser = (orgPk: number | string): Promise<any[]> => {
  return client
    .get(API_URL.ORG_USER.GET_ORG_USER_PK(orgPk))
    .then(response => response.data.results)
    .catch(error => error.response)
}

/**
 * Gets current user's organization users
 * @returns API response with organization users
 */
export const getOrguser = (): Promise<ApiClientResult> => {
  return client
    .get(API_URL.ORG_USER.GET_ORG_USERS)
    .then(response => response)
    .catch(error => error.response)
}

/**
 * Creates a new organization
 * @param payload - Organization data
 * @returns API response
 */
export const postOrganization = (
  payload: OrganizationPayload
): Promise<ApiClientResult> => {
  return client
    .post(API_URL.ORG_USER.POST_ORGANIZATION, payload)
    .then(response => response)
    .catch(error => error.response)
}

/**
 * Updates an organization user
 * @param id - OrgUser ID
 * @param payload - OrgUser data to update
 * @returns API response
 */
export const onUpdateOrgUser = (
  id: number | string,
  payload: Partial<OrgUserPayload>
): Promise<ApiClientResult> => {
  return client
    .patch(API_URL.ORG_USER.UPDATE_ORG_USER(id), payload)
    .then(response => response)
    .catch(error => error.response)
}

/**
 * Invites a user to an organization
 * @param payload - Invitation data
 * @returns API response
 */
export const postOrguserInvite = (
  payload: InvitePayload
): Promise<ApiClientResult> => {
  return client
    .post(API_URL.ORG_USER.POST_ORG_USER_INVITE, payload)
    .then(response => response)
    .catch(error => error.response)
}

/**
 * Deletes an organization user
 * @param id - OrgUser ID
 * @returns API response
 */
export const deleteOrguser = (
  id: number | string
): Promise<ApiClientResult> => {
  return client
    .delete(API_URL.ORG_USER.DELETE_ORG_USER(id))
    .then(response => response)
    .catch(error => error.response)
}
